import { AiImagePresetStyles } from "common/aiConstants";

export function getAiImageStyleTrackingProps(imageStyle?: string | null, imageStylePrompt?: string | null) {
    if (!imageStyle || imageStyle === "stock") {
        return {
            custom_style_type: null,
            custom_style_type_prompt: null,
            image_style: null
        };
    }

    const isPresetImageStyle = AiImagePresetStyles.some(style => style.style === imageStyle);

    return {
        custom_style_type: imageStyle === "custom" ? "prompt" : "preset",
        custom_style_type_prompt: imageStylePrompt,
        image_style: isPresetImageStyle ? imageStyle : imageStyle === "custom" ? "custom" : imageStyle
    };
}
